const groupedTickets = (tickets) => {
    const result = {};
    tickets.forEach((ticket) => {
        const key = `${ticket.name}-${ticket.price}`;
        if (!result[key]) {
            result[key] = {
                name: ticket.name,
                price: ticket.price,
                noOfTickets: 0,
            };
        }
        result[key].noOfTickets += 1;
    });
    return Object.values(result);
};
export default groupedTickets;
